import TalkCard from '@/components/TalkCard'
import { ITalk } from '@/network/api/keyword'
import { formatCurrencyShortForm } from '@/utils/storage'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material'

interface Props {
  data: ITalk[]
  isLocked: boolean
}

const ListOfTalkTable = ({ data, isLocked }: Props) => {
  return (
    <TableContainer component={Paper} style={{ maxHeight: '500px', overflow: 'auto', borderRadius: 8 }}>
      <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table" stickyHeader>
        <TableHead
          sx={{
            backgroundColor: 'rgba(223, 202, 114, 1)',

            height: 10,
          }}
        >
          <TableRow
            sx={{
              height: 10,
              backgroundColor: 'rgba(223, 202, 114, 1)',

              '& .MuiTableCell-head': {
                // padding: '6px 16px',
                // paddingY: { xs: 1, sm: 2 },
                backgroundColor: 'rgba(223, 202, 114, 1)',
                // fontSize: { xs: 10, sm: 16 },
                lineHeight: 1.5,
                // backgroundColor: 'blue',
              },
            }}
          >
            <TableCell>No</TableCell>
            <TableCell align="left">Content</TableCell>
            <TableCell align="center">Date</TableCell>
            <TableCell align="center">Like</TableCell>
            <TableCell align="center">Share</TableCell>
            <TableCell align="center">View</TableCell>
            <TableCell align="center">Comment</TableCell>
            <TableCell align="center">Engagement</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                '& .MuiTableCell-body': {
                  // fontSize: { xs: 10, sm: 16 },
                  // paddingY: { xs: 1, sm: 2 },
                },
              }}
            >
              <TableCell component="th" scope="row">
                {index + 1}
              </TableCell>
              <TableCell
                sx={{ maxWidth: '350px' }}
                align="left"
                style={isLocked && index + 1 >= 1 ? { filter: 'blur(4px)' } : {}}
              >
                {/* {row.media} */}
                <TalkCard
                  content={row.content}
                  displayPicture={row.displayPicture}
                  link={row.link}
                  name={row.fromName}
                  socialMedia={row.socialMedia}
                />
              </TableCell>
              <TableCell
                sx={{ maxWidth: '150px' }}
                align="center"
                style={isLocked && index + 1 >= 1 ? { filter: 'blur(4px)' } : {}}
              >
                <Typography align="center" variant="body2">
                  {new Date(row.timestamp).toLocaleString('en-US', {
                    weekday: 'long',
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true,
                  })}
                </Typography>
              </TableCell>
              <TableCell align="center" style={isLocked && index + 1 >= 1 ? { filter: 'blur(4px)' } : {}}>
                <Tooltip title={Number(row.likeCount).toLocaleString('id-ID')} arrow placement="bottom-start">
                  <Typography variant="body2">{formatCurrencyShortForm(row.likeCount)}</Typography>
                </Tooltip>
              </TableCell>
              <TableCell align="center" style={isLocked && index + 1 >= 1 ? { filter: 'blur(4px)' } : {}}>
                <Tooltip title={Number(row.shareCount).toLocaleString('id-ID')} arrow placement="bottom-start">
                  <Typography variant="body2">{formatCurrencyShortForm(row.shareCount)}</Typography>
                </Tooltip>
              </TableCell>
              <TableCell align="center" style={isLocked && index + 1 >= 1 ? { filter: 'blur(4px)' } : {}}>
                <Tooltip title={Number(row.viewCount).toLocaleString('id-ID')} arrow placement="bottom-start">
                  <Typography variant="body2">{formatCurrencyShortForm(row.viewCount)}</Typography>
                </Tooltip>
              </TableCell>
              <TableCell align="center" style={isLocked && index + 1 >= 1 ? { filter: 'blur(4px)' } : {}}>
                <Tooltip title={Number(row.commentCount).toLocaleString('id-ID')} arrow placement="bottom-start">
                  <Typography variant="body2">{formatCurrencyShortForm(row.commentCount)}</Typography>
                </Tooltip>
              </TableCell>
              <TableCell align="center" style={isLocked && index + 1 >= 1 ? { filter: 'blur(4px)' } : {}}>
                <Tooltip title={Number(row.engagement).toLocaleString('id-ID')} arrow placement="bottom-start">
                  <Typography variant="body2">{formatCurrencyShortForm(row.engagement)}</Typography>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ListOfTalkTable
